import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {Observable, Subject, Subscription} from "rxjs";
import {
    aggregateHardawareDetailDevice,
    Gradient, isNotNullOrUndefined,
    possibleComandsElementType, sensorDataType
} from "../../../providers/service/global-variables.service";
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-set-thermostat',
    templateUrl: './set-thermostat.component.html',
    styleUrls: ['./set-thermostat.component.scss'],
    standalone: false
})
export class SetThermostatComponent implements OnInit, OnDestroy {


    backgroudTemperatureColor: string = ''
    minSetTemperature = 15;
    maxSetTemperature = 35;
    stepSetTemperature = 1;
    form: UntypedFormGroup;

    typeSensorData = sensorDataType;


    possibleComandsElementType=possibleComandsElementType;


    private subscriptions: Subscription[] = [];

    private _currentValueTemperature: number | undefined
    private _currentValueMode: string | undefined


    private get currentValueTemperature() {
        return this._currentValueTemperature
    }

    private set currentValueTemperature(value) {
        this._currentValueTemperature = value;
    }

    private get currentValueMode() {
        return this._currentValueMode
    }

    private set currentValueMode(value: string | undefined) {
        this._currentValueMode = value;
    }


    get setpointKeyTmperature() {
        return this.possibleComandsElementType.setSetpointTemperature.key
    }

    get setModeTemperatureKey() {
        return this.possibleComandsElementType.setModeTemperature.key
    }

    get setCalibrationKey() {
        return this.possibleComandsElementType.calibrateDisplay.key
    }

    keysForm: string[] = [this.setCalibrationKey, this.setpointKeyTmperature, this.setModeTemperatureKey]

    saving;


    constructor(public dialogRef: MatDialogRef<SetThermostatComponent>,
                @Inject(MAT_DIALOG_DATA) public data: {
                    device: aggregateHardawareDetailDevice,
                    visualization: any | undefined,
                    saving$: Subject<{ [key: string]: boolean }> | undefined,
                    minMax: { [key: string]: { min: number, max: number } } | undefined
                },
                private fb: UntypedFormBuilder,
                iconRegistry: MatIconRegistry,
                domSanitizer: DomSanitizer,
    ) {
        iconRegistry.addSvgIcon(
            'calibration',
            domSanitizer.bypassSecurityTrustResourceUrl('assets/icon/button/screen-calibration-svgrepo-com.svg'));
        const obj: { [key: string]: any } = {};
        const objSaving: { [key: string]: boolean } = {};
        this.keysForm.forEach((key => {
            obj[key] = [{value: null, disabled: true}];
            objSaving[key] = false;
        }))
        this.saving = objSaving;
        this.form = this.fb.group(obj)
        const sub = this.form.get(this.setpointKeyTmperature)?.valueChanges.subscribe(temperature => {
            this.setGradientWithValue(temperature);
        })
        if (sub != null) {
            this.subscriptions.push(sub);
        }
    }

    public colorGradient: Gradient | undefined;

    getIndexByTemperature(temperature: number): number {
        return temperature - this.minSetTemperature + 1;
    }

    ngOnInit(): void {
        if (this.data.minMax != null && this.data.minMax[this.setpointKeyTmperature] != null) {
            this.minSetTemperature = this.data.minMax[this.setpointKeyTmperature].min
            this.maxSetTemperature = this.data.minMax[this.setpointKeyTmperature].max
        }

        const colorGradient = new Gradient();
        const colors = ["#0000FF", '#00ffff', '#00FF00', '#ffff00', "#FF0000"];
        colorGradient.setGradient(colors);
        colorGradient.setMidpoint(Math.round((this.maxSetTemperature - this.minSetTemperature) / this.stepSetTemperature))
        this.colorGradient = colorGradient;


        let index = this.data.device.sensorDataTypes.findIndex(type => type == this.typeSensorData.setTemperature)
        if (index >= 0) {
            let temperature = Math.round(this.data.device.sensorDataValues[index]);
            if (temperature < this.minSetTemperature) {
                temperature = this.minSetTemperature
            } else if (temperature > this.maxSetTemperature) {
                temperature = this.maxSetTemperature
            }
            this.currentValueTemperature = temperature;
        }

        if (this.data.visualization) {
            this.keysForm.forEach(key => {
                if (this.data.visualization[key]) {
                    this.form.get(key)?.enable({emitEvent: false});
                } else {
                    this.form.get(key)?.disable({emitEvent: false});
                }
            })
        }
        this.form.get(this.setpointKeyTmperature)?.setValue(this.currentValueTemperature, {emitEvent: false})
        this.form.get(this.setModeTemperatureKey)?.setValue(this.currentValueMode, {emitEvent: false})
        this.setGradientWithValue(this.form.get(this.setpointKeyTmperature)?.value);
        if (this.data.saving$) {
            const sub = this.data.saving$.asObservable().subscribe(changeValue => {
                if (changeValue.error) {
                    Object.keys(this.saving).forEach(key => this.saving[key] = false)
                } else {
                    Object.keys(changeValue).forEach((key: string) => {
                        if (isNotNullOrUndefined(this.saving[key])) {
                            if (key == this.setCalibrationKey && !changeValue[key]) {
                                this.form.get(key)?.reset(null, {emitEvent: false})
                            }
                            this.saving[key] = changeValue[key]
                        }
                    })
                }
            })
            if (sub != null) {
                this.subscriptions.push(sub);
            }
        }
    }

    setGradientWithValue(value: number) {
        if (value != null) {
            const getRadialGradient = (value: number) => {
                return this.colorGradient?.getColor(this.getIndexByTemperature(value))
            }
            this.backgroudTemperatureColor = getRadialGradient(value);
        }
    }


    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe())
    }

    get temperatureSet() {
        return this.form.get(this.setpointKeyTmperature)?.value
    }

    clickPlus() {
        const temperature = this.temperatureSet + this.stepSetTemperature
        if (temperature <= this.maxSetTemperature && this.form.get(this.setpointKeyTmperature)?.enabled && !this.saving[this.setpointKeyTmperature]) {
            this.form.get(this.setpointKeyTmperature)?.setValue(temperature)
        }
    }

    clickMinus() {
        const temperature = this.temperatureSet - this.stepSetTemperature
        if (temperature >= this.minSetTemperature && this.form.get(this.setpointKeyTmperature)?.enabled && !this.saving[this.setpointKeyTmperature]) {
            this.form.get(this.setpointKeyTmperature)?.setValue(temperature)
        }
    }

    setTemperature(temperature: number | any) {
        console.log(temperature)
        if (typeof temperature == "number") {
            this.form.get(this.setpointKeyTmperature)?.setValue(temperature)
        } else {
            this.form.get(this.setpointKeyTmperature)?.reset();
        }
    }

    getColor(value: string) {
        if (this.form.get(this.setModeTemperatureKey) != null && typeof this.form.get(this.setModeTemperatureKey)?.value == "string" && value.trim() == this.form.get(this.setModeTemperatureKey)?.value?.trim()) {
            return 'text-color-primary'
        } else {
            return 'text-color-accent'
        }
    }

    getColorCalibrate() {
        if (this.form.get(this.setCalibrationKey) && this.form.get(this.setCalibrationKey)?.value) {
            return 'text-color-primary'
        } else {
            return 'text-color-accent'
        }
    }

    setMode(value: string) {
        if (this.form.get(this.setModeTemperatureKey)?.enabled && !this.saving[this.setModeTemperatureKey]) {
            this.form.get(this.setModeTemperatureKey)?.setValue(value)
        }
    }

    setCalibrateDisplay() {
        if (this.form.get(this.setCalibrationKey)?.enabled && !this.saving[this.setCalibrationKey]) {
            this.saving[this.setCalibrationKey] = true;
            this.form.get(this.setCalibrationKey)?.setValue(true)
        }
    }

    approvedValue() {
        this.dialogRef.close(this.enabledValue)
    }

    get enabledValue() {
        const obj: { [key: string]: any } = {}
        Object.keys(this.form.value).forEach((key: string) => {
            if (this.form.get(key)?.enabled) {
                obj[key] = this.form.get(key)?.value;
            }
        })
        return obj
    }


}
